import React, { FC } from 'react';
import { Title } from '../developers/page-components/Title';
// import { numberFormatter } from '../../utils/utilities';
// import { DateComponent } from '../DateComponent';

// const mockData = [
// 	{
// 		type: 'money',
// 		title: 'Spent',
// 		value: 77.91,
// 	},
// 	{
// 		type: 'date',
// 		title: 'Since',
// 		value: '2024-02-16T09:14:17.509828Z',
// 	},
// 	{
// 		type: 'money',
// 		title: 'MRR',
// 		value: 0,
// 	},
//
// ];

export const ContactDetailsInsights: FC = () => {
	// const getFields = (type, value): JSX.Element => {
	// 	switch (type) {
	// 		case 'date':
	// 			return <DateComponent value={value} isTooltip additionalDateClass="fs-7"/>;
	// 		default:
	// 			return (
	// 				<div className="fs-7">
	// 					${numberFormatter(value)}
	// 				</div>
	// 			);
	// 	}
	// };
	return (
		<div className="card mb-5">
			<div className="card-body">
				<Title title="Insights" additionalClass="fs-5 fw-bolder" />
				{/*<div className="d-flex align-items-center justify-content-between">*/}
				{/*	{mockData.map(el => (*/}
				{/*		<div key={el?.title} className="mt-2">*/}
				{/*			<div className="text-muted fs-8">{el?.title}</div>*/}
				{/*			{getFields(el?.type, el?.value)}*/}
				{/*		</div>*/}
				{/*	))}*/}
				{/*</div>*/}
				<div className="h-50px d-flex align-items-center justify-content-center">
					No data to display
				</div>
			</div>
		</div>
	);
};